import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { providerInterests } from '../mockData/provider-interests-data';

const ProviderInterestsApi = [
  rest.get(`${API_ROOT}libraries/provider-interests`, (req, res, ctx) => res(ctx.json(providerInterests))),
  rest.get(`${API_ROOT}libraries/provider-interests/${providerInterests[0].id}`, (req, res, ctx) => res(ctx.json(providerInterests[0]))),
  rest.put(`${API_ROOT}libraries/provider-interests/${providerInterests[0].id}`, (req, res, ctx) => res(ctx.json(providerInterests[0]))),
  rest.post(`${API_ROOT}libraries/provider-interests`, (req, res, ctx) => res(ctx.json(providerInterests[1]))),
  rest.delete(`${API_ROOT}libraries/provider-interests/${providerInterests[0].id}`, (req, res, ctx) => res(ctx.json(providerInterests[0]))),
];

export default ProviderInterestsApi;
